import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Heading, ISingleChoiceButtonOption, SingleChoice } from '@ruby-labs/ui-core-kit';

import { RoutePath } from 'routes/route-path.constant';
import { BaseContext } from 'context/base.context';

import { useLocalStorage } from 'hooks/use-local-storage.hook';
import { useSaveAnswers } from 'hooks/use-save-answers.hook';

import { LocalStorageKeys } from 'constants/local-storage';

export const ExerciseHours = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageConfiguration } = useContext(BaseContext);

    const pageKey = LocalStorageKeys[RoutePath.ExerciseHours];

    const { pageValue, setPageValue }: any = useLocalStorage({
        key: pageKey,
        defaultValue: '',
    });

    const handleClick = (option: ISingleChoiceButtonOption) => {
        setPageValue(option);

        saveAnswers({
            key: pageKey,
            itemQuestion: { question: t('exercise-hours-title'), value: option.label },
        });

        pageConfiguration.handleOnPageComplete(option.value);
    };

    const options: ISingleChoiceButtonOption[] = [
        {
            value: 'one-hour-per-week',
            label: t('exercise-hours-option-one-hour-per-week'),
        },
        {
            value: 'one-two-hours-per-week',
            label: t('exercise-hours-option-one-two-hours-per-week'),
        },
        {
            value: 'three-five-hours-per-week',
            label: t('exercise-hours-option-three-five-hours-per-week'),
        },
        {
            value: 'more-than-five-hours-per-week',
            label: t('exercise-hours-option-more-than-five-hours-per-week'),
        }
    ];

    return (
        <>
            <Heading title={t('exercise-hours-title')} />

            <SingleChoice
                options={options}
                selectedOption={pageValue}
                onSelect={handleClick} />
        </>
    );
};
